import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { noop } from 'lodash-es';
import { useIntercomSession } from './useIntercomSession';
const IntercomStarterContext = /*#__PURE__*/ createContext({
    setEnableIntercom: noop
});
export const useIntercomStarter = ()=>useContext(IntercomStarterContext);
export function IntercomStarter(param) {
    let { children } = param;
    const { setEnableIntercom } = useIntercomSession();
    const value = useMemo(()=>({
            setEnableIntercom
        }), [
        setEnableIntercom
    ]);
    return /*#__PURE__*/ _jsx(IntercomStarterContext.Provider, {
        value: value,
        children: children
    });
}
